<div class="d-flex align-items-center mt-3 ms-2 ms-xl-3">
  <div
    class="d-flex justify-content-around align-items-center me-2 inquiry-legend-icon"
    [ngbTooltip]="'shiftStatus.legend.' + legendItem.status | translate"
    [placement]="['top', 'top-end', 'top-start']"
    [ngClass]="legendItem.iconBackground"
  >
    <span
      *ngIf="legendItem.iconText"
      [ngClass]="legendItem.icon"
      class="fw-bold"
      >{{ legendItem.iconText | translate }}</span
    >
    <i
      class="fa-solid"
      *ngIf="!legendItem.iconText"
      [ngClass]="legendItem.icon"
    ></i>
  </div>
  <span
    class="d-none d-xl-block {{ 'text-' + legendItem.status }}"
    baseTruncate
    >{{ 'shiftStatus.legend.' + legendItem.status | translate }}</span
  >
</div>
